import React from 'react';
import dayjs from 'dayjs';
import { UiComponent } from 'components';
import { ScheduleItemInputType } from 'types';
import { formatTimeRange, hasDetail } from './utils';
import * as styles from './style';

interface Props {
  dates: string[];
  date: string;
  items: ScheduleItemInputType[];
  draftId?: string;
}

function Preview({ dates, date, items, draftId }: Props) {
  return (
    <UiComponent.Box>
      <div css={styles.boxHead}>
        <UiComponent.BoxTitle
          title="앱 미리보기"
          subText={draftId ? '작성 중인 내용 포함' : undefined}
        />
      </div>
      <div css={styles.phone}>
        <div css={styles.phoneTabs}>
          {dates.map((d, index) => {
            return (
              <span key={d} css={styles.phoneTab(d === date)}>
                DAY {index + 1} {dayjs(d).format('MM.DD (ddd)')}
              </span>
            );
          })}
        </div>
        <div css={styles.timeline}>
          {items.length === 0 && (
            <p
              css={{
                padding: 24,
                textAlign: 'center',
                fontSize: 13,
                color: '#999',
              }}
            >
              등록된 일정이 없습니다
            </p>
          )}
          {items.map((item, i) => (
            <div key={item.id ?? i} css={styles.card(item.id === draftId)}>
              <p>{formatTimeRange(item).replace('–', '\n~ ')}</p>
              <div>
                <p>{item.title}</p>
                {item.summary && <p>{item.summary}</p>}
              </div>
              {hasDetail(item) && <span css={{ color: '#999' }}>›</span>}
            </div>
          ))}
        </div>
      </div>
    </UiComponent.Box>
  );
}

export default Preview;
